import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ClientRoutes = ({ user }) => {
  if (!user.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (user.role !== 'client' && !user.isImpersonating && user.viewMode !== 'client') {
    return <Navigate to="/stores" replace />;
  }
  return <Outlet />;
};

export default ClientRoutes;
